import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { SimpleLoading, PromotionalFooterPure, InputHLPure } from "../../../pures";
import {
    ButtonHLPure,
} from "../../../pures"
import "./digital-contract-template-detail.css";

//TERMINAR AQUI
const DigitalContractTemplatePdfView = ({
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    laststateNameComponentUser,
}) => {
    const { t } = useTranslation();

    const redirectToComponets = (name) => {
        setStateNameComponentUser(name);
        setHeaderTitleinDetail({ clicked: true, name: name })
    };


    return (
        < Grid
            className="digitalContractTemplates-body"
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
        >

            {/*Container primera seccion de items, fila*/}
            <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className='digitalContractTemplatesVariables-container-variables'>

                <iframe
                    name="document_pdf"
                    id="myiframe"
                    width="100%"
                    height="600px"
                    src={`https://orimi.com/pdf-test.pdf`}
                    className="canvas_container_pdf_render"
                />
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalContractTemplatesAddButtons"
            >
                <Grid
                    item
                    className="digitalContractTemplatesAddSaveButton"
                >
                    <ButtonHLPure nameBtn={t("button.return")}
                        onClickBtn={(e) => redirectToComponets(laststateNameComponentUser)} primary />

                </Grid>
            </Grid>
        </Grid>
    );
};

export default DigitalContractTemplatePdfView;